function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isEqual from 'lodash/isEqual';
import { makeBillUpfrontState } from "./makers";
export let ToggledField = /*#__PURE__*/function (ToggledField) {
  ToggledField["IsBilledUpfront"] = "isBilledUpfront";
  ToggledField["IsPaused"] = "isPaused";
  ToggledField["IsProrated"] = "isProrated";
  ToggledField["SkipBillingOnAcceptance"] = "skipBillingOnAcceptance";
  return ToggledField;
}({});

/** Toggles billing properties for a new (awaiting-approval) ongoing service. */
export function toggleNewOngoingBilling(billing, field) {
  const mode = toNewOngoingBillingMode(billing);
  const newMode = changeNewOngoingBillingMode(mode, field);
  return _objectSpread(_objectSpread({}, billing), fromNewOngoingBillingMode(newMode));
}

/** Returns valid billing properties for a new (awaiting-approval) ongoing service. */
export function getValidNewOngoingBilling(billing) {
  return fromNewOngoingBillingMode(toNewOngoingBillingMode(billing));
}
export function isValidNewOngoingBilling(billing) {
  return isEqual(getValidNewOngoingBilling(billing), billing);
}
var NewOngoingBillingMode = /*#__PURE__*/function (NewOngoingBillingMode) {
  NewOngoingBillingMode["UpfrontAndSkipBillingOnAcceptance"] = "UpfrontAndSkipBillingOnAcceptance";
  NewOngoingBillingMode["UpfrontAndBillOnAcceptance"] = "UpfrontAndBillOnAcceptance";
  NewOngoingBillingMode["UpfrontAndBillOnAcceptanceAndProrate"] = "UpfrontAndBillOnAcceptanceAndProrate";
  NewOngoingBillingMode["UpfrontAndStartPaused"] = "UpfrontAndStartPaused";
  NewOngoingBillingMode["NotUpfront"] = "NotUpfront";
  NewOngoingBillingMode["NotUpfrontAndStartPaused"] = "NotUpfrontAndStartPaused";
  NewOngoingBillingMode["NotUpfrontAndProrate"] = "NotUpfrontAndProrate";
  return NewOngoingBillingMode;
}(NewOngoingBillingMode || {});
function toNewOngoingBillingMode(billing) {
  if (billing.isBilledUpfront) {
    return billing.isPaused ? NewOngoingBillingMode.UpfrontAndStartPaused : billing.billUpfrontState.skipBillingOnAcceptance ? NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance : billing.isProrated ? NewOngoingBillingMode.UpfrontAndBillOnAcceptanceAndProrate : NewOngoingBillingMode.UpfrontAndBillOnAcceptance;
  } else {
    return billing.isPaused ? NewOngoingBillingMode.NotUpfrontAndStartPaused : billing.isProrated ? NewOngoingBillingMode.NotUpfrontAndProrate : NewOngoingBillingMode.NotUpfront;
  }
}
function fromNewOngoingBillingMode(mode) {
  switch (mode) {
    case NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance:
      return {
        isBilledUpfront: true,
        isPaused: false,
        isProrated: false,
        billUpfrontState: makeBillUpfrontState(true)
      };
    case NewOngoingBillingMode.UpfrontAndBillOnAcceptance:
      return {
        isBilledUpfront: true,
        isPaused: false,
        isProrated: false,
        billUpfrontState: makeBillUpfrontState(false)
      };
    case NewOngoingBillingMode.UpfrontAndBillOnAcceptanceAndProrate:
      return {
        isBilledUpfront: true,
        isPaused: false,
        isProrated: true,
        billUpfrontState: makeBillUpfrontState(false)
      };
    case NewOngoingBillingMode.UpfrontAndStartPaused:
      return {
        isBilledUpfront: true,
        isPaused: true,
        isProrated: false,
        billUpfrontState: makeBillUpfrontState(true)
      };
    case NewOngoingBillingMode.NotUpfront:
      return {
        isBilledUpfront: false,
        isPaused: false,
        isProrated: false,
        billUpfrontState: makeBillUpfrontState(true)
      };
    case NewOngoingBillingMode.NotUpfrontAndStartPaused:
      return {
        isBilledUpfront: false,
        isPaused: true,
        isProrated: false,
        billUpfrontState: makeBillUpfrontState(true)
      };
    case NewOngoingBillingMode.NotUpfrontAndProrate:
      return {
        isBilledUpfront: false,
        isPaused: false,
        isProrated: true,
        billUpfrontState: makeBillUpfrontState(false)
      };
  }
}
function changeNewOngoingBillingMode(mode, toggledField) {
  switch (mode) {
    case NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance:
      return fromUpfrontAndSkipBillingOnAcceptance(toggledField);
    case NewOngoingBillingMode.UpfrontAndBillOnAcceptance:
      return fromUpfrontAndBillOnAcceptance(toggledField);
    case NewOngoingBillingMode.UpfrontAndBillOnAcceptanceAndProrate:
      return fromUpfrontAndBillOnAcceptanceAndProrate(toggledField);
    case NewOngoingBillingMode.UpfrontAndStartPaused:
      return fromUpfrontAndStartPaused(toggledField);
    case NewOngoingBillingMode.NotUpfront:
      return fromNotUpfront(toggledField);
    case NewOngoingBillingMode.NotUpfrontAndStartPaused:
      return fromNotUpfrontAndStartPaused(toggledField);
    case NewOngoingBillingMode.NotUpfrontAndProrate:
      return fromNotUpfrontAndProrate(toggledField);
  }
}
function fromUpfrontAndSkipBillingOnAcceptance(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.NotUpfront;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.UpfrontAndStartPaused;
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
    // Not allowed.
    case ToggledField.SkipBillingOnAcceptance:
      return NewOngoingBillingMode.UpfrontAndBillOnAcceptance;
  }
}
function fromUpfrontAndBillOnAcceptance(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.NotUpfront;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.UpfrontAndBillOnAcceptance;
    // Not allowed.
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.UpfrontAndBillOnAcceptanceAndProrate;
    case ToggledField.SkipBillingOnAcceptance:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
  }
}
function fromUpfrontAndBillOnAcceptanceAndProrate(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.NotUpfront;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.UpfrontAndBillOnAcceptanceAndProrate;
    // Not allowed.
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.UpfrontAndBillOnAcceptance;
    case ToggledField.SkipBillingOnAcceptance:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
  }
}
function fromUpfrontAndStartPaused(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.NotUpfrontAndStartPaused;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
    case ToggledField.IsProrated:
    case ToggledField.SkipBillingOnAcceptance:
      return NewOngoingBillingMode.UpfrontAndStartPaused;
    // Not allowed.
  }
}
function fromNotUpfront(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.NotUpfrontAndStartPaused;
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.NotUpfrontAndProrate;
    case ToggledField.SkipBillingOnAcceptance:
      return NewOngoingBillingMode.NotUpfront;
    // Not allowed.
  }
}
function fromNotUpfrontAndStartPaused(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.UpfrontAndStartPaused;
    case ToggledField.IsPaused:
      return NewOngoingBillingMode.NotUpfront;
    case ToggledField.IsProrated:
    case ToggledField.SkipBillingOnAcceptance:
      return NewOngoingBillingMode.NotUpfrontAndStartPaused;
    // Not allowed.
  }
}
function fromNotUpfrontAndProrate(toggledField) {
  switch (toggledField) {
    case ToggledField.IsBilledUpfront:
      return NewOngoingBillingMode.UpfrontAndSkipBillingOnAcceptance;
    case ToggledField.IsProrated:
      return NewOngoingBillingMode.NotUpfront;
    case ToggledField.IsPaused:
    case ToggledField.SkipBillingOnAcceptance:
      return NewOngoingBillingMode.NotUpfrontAndProrate;
    // Not allowed.
  }
}